import { render } from "./CatalogItem.vue?vue&type=template&id=63b74ef3&ts=true"
import script from "./CatalogItem.vue?vue&type=script&lang=ts"
export * from "./CatalogItem.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/waga/Projects/breil/wp-content/themes/breil/addons/packages/catalog/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__